import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-0e1575ab"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "terminal-view-table-wrap" }
const _hoisted_2 = { class: "selection-bar cm-ui-mb15" }
const _hoisted_3 = ["disabled"]
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GroupTreeSelector = _resolveComponent("GroupTreeSelector")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_SearchFilterBar = _resolveComponent("SearchFilterBar")!
  const _component_BlueTipsIcon = _resolveComponent("BlueTipsIcon")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_UnauthorizedTooltip = _resolveComponent("UnauthorizedTooltip")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_TerminalIconName = _resolveComponent("TerminalIconName")!
  const _component_IPColumn = _resolveComponent("IPColumn")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_LoadMoreButton = _resolveComponent("LoadMoreButton")!
  const _component_AllScanModal = _resolveComponent("AllScanModal")!
  const _component_LighteningScanModal = _resolveComponent("LighteningScanModal")!
  const _component_UncheckRiskModal = _resolveComponent("UncheckRiskModal")!
  const _component_RemoverDetails = _resolveComponent("RemoverDetails")!
  const _directive_date_format = _resolveDirective("date-format")!
  const _directive_loading = _resolveDirective("loading")!
  const _directive_load_more = _resolveDirective("load-more")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_SearchFilterBar, {
      style: {"padding":"16px 16px 0","background-color":"var(--cm-color-card-bg)"},
      modelValue: _ctx.queryParams,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.queryParams) = $event)),
      "form-columns": _ctx.filterFormColumns,
      "show-search": true,
      "search-placeholder": _ctx.$t('common.phComputerIpUser'),
      "popover-threshold": 2,
      onSearch: _ctx.handleSearch,
      onQuery: _ctx.handleQuery,
      onReset: _ctx.handleReset
    }, {
      group_id: _withCtx(() => [
        _createVNode(_component_GroupTreeSelector, { onSelected: _ctx.updateGroupId }, null, 8, ["onSelected"])
      ]),
      actions: _withCtx(() => [
        _createVNode(_component_el_button, {
          disabled: !_ctx.state.selectCount,
          type: "primary",
          size: "small",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openModal('MODAL_LIGHTENING_SCAN')))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('safeProtectionModule.lightningScan')), 1)
          ]),
          _: 1
        }, 8, ["disabled"]),
        _createVNode(_component_el_button, {
          disabled: !_ctx.state.selectCount,
          type: "primary",
          plain: "",
          size: "small",
          class: "cm-ui-ml10",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openModal('MODAL_ALL_SCAN')))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('safeProtectionModule.fullDiskScan')), 1)
          ]),
          _: 1
        }, 8, ["disabled"]),
        (_ctx.viewMode === _ctx.TableViewMode.preview)
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              size: "small",
              class: "cm-ui-ml10",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('viewAll')))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('examinationTable.viewAllTerminals')), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue", "form-columns", "search-placeholder", "onSearch", "onQuery", "onReset"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_BlueTipsIcon, { class: "cm-ui-ml15 cm-ui-mr10" }),
      _createElementVNode("p", null, [
        _createTextVNode(_toDisplayString(_ctx.$t('safeProtectionModule.terminalSelected')) + " ", 1),
        _createElementVNode("a", {
          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.getListByMemory && _ctx.getListByMemory(...args))),
          disabled: !_ctx.state.selectCount,
          class: _normalizeClass(!_ctx.queryParams.useMemory ? 'req-primary' : 'req-default')
        }, _toDisplayString(_ctx.state.selectCount), 11, _hoisted_3),
        _createTextVNode(" " + _toDisplayString(_ctx.$t('safeProtectionModule.terminalUnit')), 1)
      ]),
      _createVNode(_component_el_button, {
        class: "btnbtn cm-ui-ml10",
        type: "text",
        disabled: _ctx.calcActionBtnDisableStatus(),
        onClick: _ctx.selectAll
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('safeProtectionModule.selectCurrentGroup')), 1)
        ]),
        _: 1
      }, 8, ["disabled", "onClick"]),
      _createVNode(_component_el_button, {
        class: "btn",
        type: "text",
        disabled: !_ctx.state.selectCount,
        onClick: _ctx.selectCancel
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('safeProtectionModule.deselect')), 1)
        ]),
        _: 1
      }, 8, ["disabled", "onClick"])
    ]),
    _createElementVNode("div", {
      class: "table-wrapper",
      style: _normalizeStyle({ height: _ctx.viewMode === _ctx.TableViewMode.full ? 'calc(100% - 120px)' : 'calc(400px - 56px)' })
    }, [
      _withDirectives((_openBlock(), _createBlock(_component_el_table, {
        "empty-text": _ctx.$t('common.noData'),
        data: _ctx.tableData,
        "default-sort": _ctx.defaultSort,
        width: "100%",
        height: _ctx.viewMode === _ctx.TableViewMode.full ? '100%' : undefined,
        onSortChange: _ctx.handlerSort,
        ref: "multipleTable",
        onSelect: _ctx.handleSelectionChange,
        onSelectionChange: _ctx.handleSelectionChange
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            type: "selection",
            selectable: (row) => !(_ctx.state.selectAll || _ctx.isDisabled(row))
          }, {
            default: _withCtx((scope) => [
              _createVNode(_component_UnauthorizedTooltip, {
                "permission-key": _ctx.ModulePermissionKey[scope.row.area_type],
                "device-id": scope.row.device_id,
                "auth-status": _ctx.getAuthByList(scope.row.auth_status, _ctx.ModulePermissionKey[scope.row.area_type]),
                "area-type": scope.row.area_type,
                onAuthSuccess: _ctx.refreshData
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_checkbox, {
                    "model-value": scope.row.$selected,
                    disabled: _ctx.state.selectAll || _ctx.isDisabled(scope.row),
                    onChange: ($event: any) => (_ctx.handleCheckbox(scope.row))
                  }, null, 8, ["model-value", "disabled", "onChange"])
                ]),
                _: 2
              }, 1032, ["permission-key", "device-id", "auth-status", "area-type", "onAuthSuccess"])
            ]),
            _: 1
          }, 8, ["selectable"]),
          _createVNode(_component_el_table_column, {
            prop: "computer_name",
            label: _ctx.$t('listColumns.computerName'),
            sortable: "custom",
            "show-overflow-tooltip": ""
          }, {
            default: _withCtx((scope) => [
              _createVNode(_component_TerminalIconName, {
                class: "cm-link",
                computer_name: scope.row.computer_name,
                system_type: scope.row.system_type,
                login_status: scope.row.login_status,
                onClick: ($event: any) => (_ctx.handleRemoverDetailsShow(scope.row))
              }, null, 8, ["computer_name", "system_type", "login_status", "onClick"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "user_mark",
            label: _ctx.$t('listColumns.userMark'),
            "show-overflow-tooltip": ""
          }, null, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "group_name",
            label: _ctx.$t('listColumns.groupName')
          }, null, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "risk_count",
            sortable: "custom",
            label: _ctx.$t('safeProtectionModule.unhandledRiskCount')
          }, {
            default: _withCtx((scope) => [
              _createElementVNode("span", {
                class: "cm-link-light",
                onClick: ($event: any) => (_ctx.handleRemoverDetailsShow(scope.row))
              }, _toDisplayString(scope.row.risk_count), 9, _hoisted_4)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "last_scan_time",
            label: _ctx.$t('safeProtectionModule.lastScanTimeCol'),
            sortable: "custom"
          }, {
            default: _withCtx((scope) => [
              (scope.row.last_scan_time)
                ? _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_5, null, 512)), [
                    [_directive_date_format, {value: scope.row.last_scan_time * 1000, format: 'YYYY-MM-DD HH:mm'}]
                  ])
                : (_openBlock(), _createElementBlock("span", _hoisted_6, "--"))
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "scan_type",
            label: _ctx.$t('safeProtectionModule.lastScanType')
          }, {
            default: _withCtx((scope) => [
              _createTextVNode(_toDisplayString(_ctx.scanTypeList[scope.row.scan_type]), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "scan_status",
            label: _ctx.$t('safeProtectionModule.scanStatus')
          }, {
            default: _withCtx((scope) => [
              _createTextVNode(_toDisplayString(_ctx.scanStatusList[scope.row.scan_status]), 1),
              _createElementVNode("div", {
                class: _normalizeClass({'dot-flashing': scope.row.scan_status === 2 })
              }, null, 2)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            label: _ctx.$t('listColumns.ipAddress')
          }, {
            default: _withCtx((scope) => [
              _createVNode(_component_IPColumn, {
                cip: scope.row.client_ip,
                sip: scope.row.system_ip
              }, null, 8, ["cip", "sip"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "system_name",
            "min-width": "160px",
            label: _ctx.$t('safeProtectionModule.os')
          }, null, 8, ["label"])
        ]),
        _: 1
      }, 8, ["empty-text", "data", "default-sort", "height", "onSortChange", "onSelect", "onSelectionChange"])), [
        [_directive_loading, _ctx.loading],
        [_directive_load_more, _ctx.loadMoreData]
      ])
    ], 4),
    (_ctx.viewMode === _ctx.TableViewMode.full)
      ? (_openBlock(), _createBlock(_component_LoadMoreButton, {
          key: 0,
          loading: _ctx.loading,
          current: _ctx.tableData.length,
          total: _ctx.total,
          onLoadMore: _ctx.loadMoreData
        }, null, 8, ["loading", "current", "total", "onLoadMore"]))
      : _createCommentVNode("", true),
    _createVNode(_component_AllScanModal, {
      show: _ctx.scanModal.MODAL_ALL_SCAN,
      count: _ctx.state.selectAll ? _ctx.state.data.enable_total : _ctx.state.selectCount,
      onCloseVirusScanModal: _ctx.closeVirusScanModal,
      onScanTerminal: _ctx.scanTerminal
    }, null, 8, ["show", "count", "onCloseVirusScanModal", "onScanTerminal"]),
    _createVNode(_component_LighteningScanModal, {
      show: _ctx.scanModal.MODAL_LIGHTENING_SCAN,
      count: _ctx.state.selectAll ? _ctx.state.data.enable_total : _ctx.state.selectCount,
      onCloseVirusScanModal: _ctx.closeVirusScanModal,
      onScanTerminal: _ctx.scanTerminal
    }, null, 8, ["show", "count", "onCloseVirusScanModal", "onScanTerminal"]),
    _createVNode(_component_UncheckRiskModal, {
      show: _ctx.scanModal.UNCHECK_RISK_MODAL,
      content: _ctx.detailModalContent,
      onCloseVirusScanModal: _ctx.closeVirusScanModal
    }, null, 8, ["show", "content", "onCloseVirusScanModal"]),
    _createVNode(_component_RemoverDetails, {
      modelValue: _ctx.removerDetailsVisible,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.removerDetailsVisible) = $event)),
      "trojan-info": _ctx.currentRow
    }, null, 8, ["modelValue", "trojan-info"])
  ]))
}